import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import Tabulator from 'tabulator-tables';
import { AdminService } from 'src/app/services/admin/admin.service';
import { WHAT } from '../../classes';


@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.less']
})
export class CountriesComponent implements OnInit, OnDestroy {
  private table: Tabulator;

  constructor(private ngbActiveMod: NgbActiveModal, private admin: AdminService) { }

  ngOnInit() {
    this.initTable();
  }

  ngOnDestroy() {
    this.table.clearData();
  }

  // closes the modal
  public closeModal() {
    this.ngbActiveMod.close({ task: 'close modal', success: true });
  }

  // inits the table
  private initTable() {
    this.table = new Tabulator('#countriesTable', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'userid',
      layout: 'fitColumns',
      columns: [
        { title: 'Name', field: 'name', sorter: 'string' },
        { title: 'Count', field: 'value', sorter: 'number' },
      ],
      // rowClick: (e, row) => {
      //   const data = row.getData();
      //   const newData = {
      //     from: 'users',
      //     data: data
      //   };

      //   // mouse click event
      //   this.loadModal(newData);
      // },
      // rowTap: (e, row) => {
      //   const data = row.getData();
      //   const newData = {
      //     from: 'users',
      //     data: data
      //   };

      //   // touch screen tap
      //   this.loadModal(newData);
      // }
    });

    this.getAllCountries();
  }

  // search table
  public searchTable(searchValue) {
    const filters = [];
    const columns = this.table.getColumns();

    columns.forEach(function (column) {
      filters.push({
        field: column.getField(),
        type: 'like',
        value: searchValue,
      });
    });

    this.table.setFilter([filters]);
  }

  // get all countries
  private async getAllCountries() {
    // get country data
    let data;
    try {
      data = await this.admin.GET(WHAT.CountryAlt);
    } catch (e) {
      console.log(e);
      throw e;
    }

    this.updateTableRow(data);
  }

  // updates table
  private updateTableRow(rows) {
    this.table.addData(rows);
  }

}
